import { defineComponent as _defineComponent } from 'vue'
import {onMounted, onUnmounted, reactive, ref} from "vue";
import { useUserServiceStore } from "@/store/userService.store";
import { useToast } from "vue-toastification";
import {Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalModal',
  emits: ['close', 'submit'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const toast = useToast();

const emit = __emit;
const accepted = reactive({checkbox : false, enabled: false});
const terms = ref();


onMounted(()=>{
  terms.value.addEventListener('scroll', checkScrollBar );
});

function closePopup(){
  emit('close');
  terms.value.removeEventListener('scroll', checkScrollBar );
}
function checkScrollBar(){
  const clientHeight = terms.value.clientHeight;
  const scrollHeight = terms.value.scrollHeight;
  const scrollTop = terms.value.scrollTop;
  const res = (scrollTop / (scrollHeight - clientHeight)) * 100;
  const percents = res.toFixed(0);
  if (percents != 100) {
    return;
  }
  accepted.enabled = true;
}
document.body.style.overflow = "hidden";
onUnmounted(() => {
  document.body.style.overflow = "auto";
});
//TODO: check this metchod
function submit(){
  useUserServiceStore().approveTerms(onSuccessPairing, onFail, true).then((res)=>{
    terms.value.removeEventListener('scroll', checkScrollBar );
    emit('submit');
  });
}

function onSuccessPairing(){
  toast.success('Sale terms accepted');
}

function onFail(){
  toast.error('An error occured');
}

const __returned__ = { toast, emit, accepted, terms, closePopup, checkScrollBar, submit, onSuccessPairing, onFail, get Field() { return Field } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})